import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { mobile, tablet } from '~styles/global'
import SanityLink from '~components/SanityLink'
import { CartPlus } from '~components/Svg'
import Button from '~components/Button'
import Image from '~components/Image'
import { Link } from 'gatsby'
import resolveLink from '~utils/resolveLink'
import useWindow from '~utils/useWindow'
import { useCart } from '~context/siteContext'

const ProductTile = ({ className, product }) => {

	const [hover, setHover] = useState(false)
	const transformRef = useRef()
	const [transformHeight, setTransformHeight] = useState()
	const w = useWindow()
	const { addItem, openCart } = useCart()
	const variant = product?.store?.variants[0]

	useEffect(() => {
		setTransformHeight(transformRef?.current?.clientHeight)
	}, [transformRef?.current, w.innerWidth])

	const add = variant => {
		addItem({
			...variant, 
			qty: 1,
			productTitle: product?.store?.title,
			productImage: product?.store?.previewImageUrl,
			// Currently we can't limit the qty because Sanity no longer holds the data
			maxQty: null,
			slug: product?.store?.slug
		})
		openCart()
	}

	return (
		<Wrap 
			className={className} 
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
		>
			<ThumbnailLink to={resolveLink(product)}>
				<Thumbnail 
					image={product?.thumbnailImage} 
					aspectratio={1} 
					hover={hover} 
					transformHeight={transformHeight}
				/>
			</ThumbnailLink>
			<Content>
				<HiddenContent ref={transformRef} hover={hover}> 
					<ShortDesk className='h5'>
						{product?.shortDescription}
					</ShortDesk>
					<Center>
						<AddToCart onClick={() => add({...variant})} disabled={product.comingSoon}>
							<CartIcon />
						Add to cart
						</AddToCart>
					</Center>
				</HiddenContent>
				<VisibleContent to={resolveLink(product)}>
					<Title>{product?.store?.title}</Title>
					{product.comingSoon ?
						<Soon>
							<h6>Coming soon</h6>
						</Soon>
						:
						<Price>
							<>
								<Case className='h7'>Case of 24</Case>
								<PriceNum><Dollar>$</Dollar>{product?.store?.variants[0].store?.price}</PriceNum>
							</>
						</Price>
					}
				</VisibleContent>
			</Content>
		</Wrap>
	)
}

const Wrap = styled.div`
	grid-column: span 4;
	position: relative;
	${tablet}{
		grid-column: span 6;
	}
	${mobile}{
		grid-column: span 12;
	}
`
const ThumbnailLink = styled(Link)`
	
`
const LinkOverlay = styled(Link)`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 2;
`
const Thumbnail = styled(Image)`
	border-radius: 10px;
	overflow: hidden;
	transform: ${ props => props.hover ? `translateY(calc(-${props.transformHeight}px + var(--l)))` : 'translateY(0)'};
	transition: transform 0.3s;
	margin-bottom: var(--l);
	position: relative;
	z-index: 1;
	${mobile}{
		margin-bottom: 0px;
		transform: none;
	}
`
const Content = styled.div`
	position: relative;
`
const HiddenContent = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-column-gap: var(--m);
	padding: var(--s) 0;
	position: absolute;
	bottom: 100%;
	opacity: ${ props => props.hover ? '1' : '0'};
	pointer-events: ${ props => props.hover ? 'all' : 'none'};
	transition: opacity 0.25s;
	transition-delay: ${ props => props.hover ? '0.1s' : '0s'};
	${mobile}{
		position: relative;
		opacity: 1;
		pointer-events: all;
	}
`
const ShortDesk = styled.div`
`
const Center = styled.div`
	align-self: center;
	justify-self: end;
`
const AddToCart = styled(Button)`
	pointer-events: ${props => props.disabled ? 'none' : 'all'};
	opacity: ${props => props.disabled ? 0.4 : 1};
`
const VisibleContent = styled(Link)`
	border-top: 1px solid var(--white);
	border-bottom: 1px solid var(--white);
	display: flex;
	align-items: center;
`

const CartIcon = styled(CartPlus)`
	width: 23px;
	margin-right: 12px;
	margin-top: -3px;
`

const Title = styled.h4`
	flex: 1;
`

const Price = styled.div`
	justify-content: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 54px;
	width: 115px;
	border-left: 1px solid;
`

const Soon = styled.div`
	justify-content: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 54px;
	padding: 0 var(--s);
	/* width: 115px; */
	border-left: 1px solid;
`

const Case = styled.div`
	margin-bottom: 3px;
`
const Dollar = styled.span`
	font-size: 55%;
	position: relative;
	top: 0.3em;
`
const PriceNum = styled.h4`
	display: flex;
	align-items: flex-start;
`
ProductTile.propTypes = {
	className: PropTypes.string,
	product: PropTypes.object,
}

export default ProductTile